// import { useState } from 'react';

// const useNotification = () => {
//   const [notification, setNotification] = useState({
//     open: false,
//     message: '',
//     severity: 'info'
//   });

//   const showNotification = (message, severity = 'info') => {
//     debugger
//     setNotification({
//       open: true,
//       message,
//       severity
//     });
//   };

//   const hideNotification = () => {
//     setNotification(prev => ({ ...prev, open: false }));
//   };

//   return {
//     notification,
//     showNotification,
//     hideNotification
//   };
// };

// export default useNotification;



import { useState } from 'react';

const useNotification = () => {
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'info',
    autoHideDuration: 6000,
    anchorOrigin: { vertical: 'top', horizontal: 'right' }
  });

  const showNotification = (message, severity = 'info', options = {}) => {     
    setNotification({
      open: true,
      message,
      severity,
      ...options
    });
  };

  const hideNotification = () => {
    setNotification(prev => ({ ...prev, open: false }));
  };

  return {
    notification,
    showNotification,
    hideNotification
  };
};

export default useNotification;
